/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Sagas
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import get from 'lodash/get';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, WIDGET_API, WIDGET_MULTI_BALANCES } from '../../../../../modules/app/Api';
import { makeSelectLocalStorageSelectedAccount } from '../../../../../modules/storage/storageSelectors';
import { requestSaga } from '../../../../../sagas/requestSaga';
import { widgetMultiBalancesGetListFailure, widgetMultiBalancesGetListSuccess } from './widgetMultiBalancesActions';
import { IWidgetMultiBalanceResponse } from './widgetMultiBalancesTypes';

export function* widgetMultiBalancesGetListSaga(): SagaIterator {
    const selectedAccount = (yield select(makeSelectLocalStorageSelectedAccount())).id;
    const URL = API_HOSTNAME + WIDGET_API + WIDGET_MULTI_BALANCES + `/${selectedAccount}`;

    try {
        const response: IWidgetMultiBalanceResponse = yield call(requestSaga, URL, 'GET');
        const multiBalances = get(response, 'multiBalances', []);

        yield put(widgetMultiBalancesGetListSuccess({
            list: multiBalances,
        }));
    } catch (error: any) {
        yield put(widgetMultiBalancesGetListFailure(error.toString()));
    }
}
